import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Stack, Box, Container, Typography, useMediaQuery } from '@mui/material';
import { useClient } from '../../../context/ClientContext';
import ClientButton from './Clientbutton';

/**
 * React functional component representing the Master Face Scan Error Page.
 * @component
 * @returns {JSX.Element} The rendered MasterFaceScanErrorPage component.
 */
export const MasterFaceScanErrorPage = () => {
  const { clientId, theme, landing } = useClient();
  const navigate = useNavigate();
  const { encodedKey } = landing || {};
  const isSmallScreen = useMediaQuery( '(max-width:600px)' );

  // Helper function to get the correct navigation URL based on the client ID
  const getNavigationUrl = () => {
    return `/${ clientId }-pre-face-scan`;
  };

  const navigateToScan = () => {
    // Navigate to the appropriate pre-face-scan page with error state
    navigate( getNavigationUrl(), {
      state: {
        isFaceScanFailed: true,
      },
    } );
  };

  const startNewAssessmentHandler = () => {
    // Navigate to the landing page
    navigate( `/${ clientId }-landing?key=${ encodedKey }` );
  };

  return (
    <Container
      maxWidth="lg"
      sx={ {
        px: 4,
      } }
    >
      <Stack spacing={ 2 } alignItems="center" justifyContent="center" sx={ { height: '100vh' } }>
        <Typography
          variant="h4"
          sx={ {
            fontWeight: 600,
            textAlign: 'center',
            ...( isSmallScreen ? { fontSize: 20 } : {} ),
            mb: 3,
            color: '#30373E',
          } }
        >
          Face Scan Service Unavailable
        </Typography>
        <Typography
          sx={ {
            marginTop: 4,
            maxWidth: '800px',
            width: '80%',
            fontSize: { xs: '13px', sm: '15px', md: '15px' },
            fontWeight: 400,
            lineHeight: { xs: '18px', sm: '22px', md: "24px" },
            textAlign: 'center',
            mb: 4
          } }
        >
          We're sorry for any inconvenience, but our system is currently experiencing a high volume of users.
          Please consider trying again at a later time. Thank you for understanding!
        </Typography>
        <Box
          sx={ {
            py: 3,
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: {
              xs: 'column',
              sm: 'row',
            },
            justifyContent: 'center',
            alignItems: 'center',
            width: 1,
            gap: {
              xs: 2,
              sm: 2,
            },
          } }
        >
          <ClientButton
            text="Retry a face scan assessment"
            onClick={ navigateToScan }
            backgroundColor={ theme.primaryColor }
            sx={ {
              maxWidth: "320px",
              width: "100%",
              fontSize: { xs: '13px', sm: '15px', md: '16px' },
            } }
        />
          <ClientButton
            text="Start a new assessment"
            onClick={ startNewAssessmentHandler }
            backgroundColor={ theme.primaryColor }
            sx={ {
              maxWidth: "320px",
              width: "100%",
              fontSize: { xs: '13px', sm: '15px', md: '16px' },
            } }
        />
        </Box>
      </Stack>
    </Container>
  );
};

export default MasterFaceScanErrorPage;